import { render } from "./GamePage.vue?vue&type=template&id=08b62715&scoped=true&ts=true"
import script from "./GamePage.vue?vue&type=script&lang=ts"
export * from "./GamePage.vue?vue&type=script&lang=ts"

import "./GamePage.vue?vue&type=style&index=0&id=08b62715&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b62715"]])

export default __exports__